import {useTranslation} from "react-i18next";
import {getTranslateKey} from "../helpers/getTranslateKey";

export const useTranslate = value => {
  const {t} = useTranslation();
  const translateKey = typeof value === 'string' ? getTranslateKey(value) : "";
  const translateValue = typeof value === 'string' ? t(getTranslateKey(value)) ?? value : value;
  return [translateKey, translateValue];
}